export default __webpack_public_path__ + "static/media/SouthAmerica_07.899b7bcd.png";